// src/components/layout/AppShell.jsx
import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

/**
 * Light-theme page chrome. No global background pattern — the original
 * site uses dot patterns *inside* dark navy panels, not on the page
 * itself. Panels that want the texture import StarField themselves.
 *
 * Props:
 *   - showNav, showFooter: defaults true. Auth screens pass showNav=false.
 *   - bare:    shortcut hiding both nav + footer.
 *   - maxWidth: optional content max-width.
 */
export default function AppShell({
  children,
  showNav = true,
  showFooter = true,
  bare = false,
  maxWidth = "1180px",
  className = "",
}) {
  const showNavFinal = bare ? false : showNav;
  const showFooterFinal = bare ? false : showFooter;

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", color: "var(--txt)" }}>
      {showNavFinal && <NavBar />}

      <main
        className={`${showNavFinal ? "pt-14" : ""} ${className}`}
        style={{ maxWidth, margin: "0 auto" }}
      >
        {children}
      </main>

      {showFooterFinal && <Footer />}
    </div>
  );
}
